import Api from './Api';

const COMPANIES_URL = `${process.env.REACT_APP_BASE_URL}/v2/companies`;

export const getCompanies = () => Api.get(COMPANIES_URL);
export const addCompany = (data) => Api.post(COMPANIES_URL, data);
export const deleteCompany = (id) => Api.delete(`${COMPANIES_URL}/${id}`);
export const createStockSplit = (companyId, data) =>
  Api.post(`${COMPANIES_URL}/${companyId}/stock-splits`, data);
export const getStockSplits = (companyId) =>
  Api.get(`${COMPANIES_URL}/${companyId}/stock-splits`);
export const getCompanyMetricsHistory = (companyId, range) =>
  Api.get(`${COMPANIES_URL}/${companyId}/metrics/history?range=${range}`);
